import {PfileIds, PfileRow} from "./PfileTypes";
import {UploaderImageData} from "../ingest/IngestImageCreateReq";
import {JobType} from "../job/JobTypes";
import {PfileTypeId} from "./PFileType";

export function extractFirstId(ids: PfileIds): number | null {
    return ids.appCfgId ?? ids.listId ?? ids.llId ?? ids.playerId;
}

export function pfileIdsToUploaderImgData(pfileIds: PfileIds, jobType: JobType): UploaderImageData {
    return {
        appCfgId: pfileIds.appCfgId,
        listId: pfileIds.listId,
        llId: pfileIds.llId,
        playerId: pfileIds.playerId,
        pfileTypeId: pfileIds.pfileTypeId,
        jobType: jobType,
        mediaId: null,
        poster: null,
        thumb: null
    };
}

export type CreatePfileIds = {
    appCfgId?: number;
    llId?: number;
    listId?: number;
    playerId?: number;
    pfileTypeId: PfileTypeId;
}

export function createPfileIds(createIds: CreatePfileIds): PfileIds {
    return {
        appCfgId: createIds.appCfgId || null,
        listId: createIds.listId || null,
        llId: createIds.llId || null,
        playerId: createIds.playerId || null,
        pfileTypeId: createIds.pfileTypeId
    };
}

export function getPfiles(pfiles: PfileRow[], pfileTypes: PfileTypeId[]): PfileRow[] {
    return pfiles.filter(pfile => pfileTypes.includes(pfile.pfileIds.pfileTypeId));
}

export function getFileIds(pfiles: PfileRow[], pfileTypes: PfileTypeId[]): number[] {
    return getPfiles(pfiles, pfileTypes).map(pfile => pfile.fileId);
}